export default __webpack_public_path__ + "static/media/VSH Connection Technology.3bce4939.png";